
import { Component, Vue, Prop } from 'vue-property-decorator';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import { EliotModule } from '~/store/modules/eliot';

@Component({
    components: {
        NetatmoIcon,
    },
})
export default class DeletePlantComponent extends Vue {
    @Prop() plantId!: string;
    @Prop() plantName!: string;

    isDialogOpen = false;

    async deletePlant() {
        EliotModule.deletePlant(this.plantId);
        this.isDialogOpen = false;
    }
}
